import React from 'react'
import { Platform } from 'react-native'
import { turnPanelConcept, turnPanelConceptCss } from './turnPanelConcepts'

export function TurnPanelConceptStyles({ conceptId, dark, scopeSelector }: { conceptId?: string; dark: boolean; scopeSelector?: string }) {
  const concept = turnPanelConcept(conceptId)
  if (!concept || Platform.OS !== 'web') return null
  return React.createElement('style', { 'data-turn-panel-concept': concept.id }, turnPanelConceptCss(concept, dark, scopeSelector))
}
